import { Result } from '@standardnotes/domain-core';
export class ResendMessage {
    constructor(sendMessage, encryptMessage) {
        this.sendMessage = sendMessage;
        this.encryptMessage = encryptMessage;
    }
    async execute(params) {
        const encryptedMessage = this.encryptMessage.execute({
            message: params.decryptedMessage,
            keys: params.keys,
            recipientPublicKey: params.recipient.publicKeySet.encryption,
        });
        if (encryptedMessage.isFailed()) {
            return Result.fail(encryptedMessage.getError());
        }
        const sendMessageResult = await this.sendMessage.execute({
            recipientUuid: params.recipient.contactUuid,
            encryptedMessage: encryptedMessage.getValue(),
            replaceabilityIdentifier: params.rawMessage.replaceability_identifier || undefined,
        });
        return sendMessageResult;
    }
}
